import { createCrmCommentHooks } from "./useCrmComments";

export const useContactNoteComments = createCrmCommentHooks('contacts', 'notes');
export const useContactTaskComments = createCrmCommentHooks('contacts', 'tasks');

export const useCompanyNoteComments = createCrmCommentHooks('companies', 'notes');
export const useCompanyTaskComments = createCrmCommentHooks('companies', 'tasks');

export const useDealNoteComments = createCrmCommentHooks('deals', 'notes');
export const useDealTaskComments = createCrmCommentHooks('deals', 'tasks');